import { Grid, ISelectOption, Toggle } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { IFileExportFilters } from '../entities';

export interface IProps {
  handleFilterChange: (value: string | boolean | ISelectOption<string>, type: string) => void;
  filters: IFileExportFilters;
}

export const FileExportFilters = ({ handleFilterChange, filters }: IProps): JSX.Element => {
  const { t } = useTranslation('fileExport');

  const handleEnabledFolderFilterChange = (value: boolean): void => {
    handleFilterChange(value, 'enabledFolders');
  };

  return (
    <>
      <Grid columnMaxWidth={{ value: 20, unit: 'rem' }}>
        <Toggle
          ariaLabel={t('filter.enabled')}
          label={t('filter.enabled')}
          checked={filters.enabledFolders}
          onChange={handleEnabledFolderFilterChange}
          inputId="filter-enabled"
        />
      </Grid>
    </>
  );
};

export default FileExportFilters;
